import React from 'react';
import { useSelector } from 'react-redux';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';
import { useGroupTranslator } from '../../../../../components/i18n/GroupTranslationContext';

import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector } from '../../../selector/selectionToolsSelector';

import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import MobileTagsSheet from './sheet/MobileTagsSheet';
import MobileTagEditSheet from './sheet/MobileTagEditSheet';

import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';
import useTagPopupsState from './useTagPopupsState';

type MobileTagsToolProps = TagsToolbarPopupProps & {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const MobileTagsTool: React.FC<MobileTagsToolProps> = (props) => {
    const { selectedElements } = props;
    const translate = useGroupTranslator();
    const mobileName = translate('mobile.tags');

    const elementIds = selectedElements.map(getElementId).toArray();
    const selectedTaskListId = useSelector(getSelectedTaskIdSelector);
    const focusElementIds = selectedTaskListId ? [selectedTaskListId] : elementIds;

    const tagsSheetProps = useSheet(SheetId.TagsTool, focusElementIds[0]);
    const {
        isSheetOpen: isTagsSheetOpen,
        dispatchOpenSheet: dispatchTagsOpenSheet,
        dispatchCloseSheet: dispatchTagsCloseSheet,
    } = tagsSheetProps;
    const tagEditSheetProps = useSheet(SheetId.TagEditTool, focusElementIds[0]);
    const { dispatchOpenSheet: dispatchOpenTagEditSheet, dispatchCloseSheet: dispatchCloseTagEditSheet } =
        tagEditSheetProps;

    const { currentlyEditingTag, userRootPath, shareRootPath, handleClickEdit } =
        useTagPopupsState(dispatchOpenTagEditSheet);

    return (
        <div className="MobileTagsTool">
            <ToolbarTool name={mobileName} isOpen={isTagsSheetOpen} onClick={dispatchTagsOpenSheet}>
                <Icon name={'toolbar-tag'} />
            </ToolbarTool>
            <MobileTagsSheet
                {...props}
                sheetProps={tagsSheetProps}
                shareRootPath={shareRootPath}
                userRootPath={userRootPath}
                closePopup={dispatchTagsCloseSheet}
                handleClickEdit={handleClickEdit}
            />
            <MobileTagEditSheet
                {...props}
                sheetProps={tagEditSheetProps}
                shareRootPath={shareRootPath}
                closePopup={dispatchCloseTagEditSheet}
                tag={currentlyEditingTag}
            />
        </div>
    );
};

export default MobileTagsTool;
